import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@websky/core/src/theme';
import RootProfileControls from '@websky/core/src/ProfileControls/components/ProfileControls';
import Button from '@websky/core/src/Button';
import { useCallback } from 'react';
var YAMAL_URL = 'https://yamalaero.ru';
var ACCOUNT_ROUTES = {
    orders: '/account/orders'
};
var ProfileControls = function () {
    var t = useTranslation('Account').t;
    var theme = useTheme('ProfileControls').ProfileControls;
    var history = useHistory();
    var onBuyTicket = useCallback(function () {
        window.open(YAMAL_URL, '_blank');
    }, []);
    var onGoToOrders = useCallback(function () {
        history.push(ACCOUNT_ROUTES.orders);
    }, [history]);
    var onGoToAppeals = useCallback(function () {
        window.open("".concat(YAMAL_URL, "/contacts/feedback"), '_blank');
    }, []);
    var renderActions = React.useCallback(function (_a) {
        var openBookingModal = _a.openBookingModal, openCheckinModal = _a.openCheckinModal;
        return (React.createElement("div", { className: theme.actions },
            React.createElement(Button, { onClick: onBuyTicket }, t('Buy a ticket')),
            React.createElement(Button, { onClick: onGoToOrders }, t('My orders')),
            React.createElement(Button, { onClick: onGoToAppeals }, t('My appeals')),
            React.createElement(Button, { onClick: openBookingModal }, t('I have a booking')),
            React.createElement(Button, { onClick: openCheckinModal }, t('Check-in'))));
    }, [onBuyTicket, onGoToOrders, onGoToAppeals]);
    return React.createElement(RootProfileControls, { renderActions: renderActions });
};
export default ProfileControls;
